<template>
   <div class="w-100">
        <v-img
            :lazy-src="data[imgSise()].sizes.thumbnail"
            lazy
            :src="data[imgSise()].url"
            cover
            fetchpriority="high"
            width="100%"
            :position="data.image_position_x+'% '+data.image_position_y+'% '"
            min-height="520"
            max-height="70vh"
            :gradient="gradientColor[data.gradient]"
            :alt="data.title+' - '+data.sub_title"
        >
         <TitleSubTitleHero :color="data.gradient" :is_h1="data.is_h1" :title="data.title" :sub_title="data.sub_title" :button="(data.has_button) ? data.button : null"></TitleSubTitleHero>
        </v-img>
   </div>
</template>

<script setup>
import TitleSubTitleHero from './subComponents/TitleSubTitleHero.vue'
</script>

<script>
export default {
   props:{
       data:{
           required: true,
           type: Object,
       }
   },
   data: () => ({
    breakpoints: {
            xs: 'mobile_image',
            sm: 'mobile_image',
            md: 'tablet_image',
            lg: 'desktop_image',
            xl: 'desktop_image',
            xxl: 'desktop_image',
    },
    gradientColor:{
        black: "to bottom, rgba(0,0,0,1),rgba(0,0,0,1),  rgba(0,0,0,0.3), rgba(0,0,0,0.2), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(0,0,0,0.51), rgba(0,0,0,1)",
        blackbrown: "to bottom, rgba(0,0,0,1),rgba(0,0,0,1),  rgba(0,0,0,0.3), rgba(0,0,0,0.2), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(72,59,51,0.1),  rgba(72,59,51,0.51), rgba(72,59,51,1)",
        white: "to bottom, rgba(255,255,255,1), rgba(255,255,255,1), rgba(255,255,255,0.51), rgba(255,255,255,0.31), rgba(255,255,255,0.1), rgba(255,255,255,0.0), rgba(255,255,255,0.0)",
        primary: "to bottom, rgba(--v-theme-primary,1), rgba(--v-theme-primary,1), rgba(--v-theme-primary,0.51), rgba(0,0,0,0.31), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0)"
    }
   }),
   methods:{
        imgSise(){
            return this.breakpoints[this.$vuetify.display.name]
        },
   }
}
</script>